<template>
  <div class="startup-zone-page">
    <!-- Hero Section with Background -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="page-title">Explore The Startup Zone</h1>
      </div>
    </section>

    <!-- What is Startup Zone Section -->
    <section class="about-section">
      <div class="container">
        <h2 class="section-title">What is the Startup Zone All About?</h2>
        <p class="section-subtitle">
          Get in the spotlight at Startup Zone for only <span class="price-tag">$1900!</span>
        </p>

        <div class="flip-cards-grid">
          <!-- Card 1 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">Claim Your Spotlight</h3>
                <span class="card-number">1</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">Claim Your Spotlight</h3>
                <p class="card-description">
                  For just $1900, lock in a booth space and get face time with over 5000+ founders, CEOs, investors, and thought leaders. Position your startup where it matters—right in the heart of the action.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">Pitch to Top Investors</h3>
                <span class="card-number">2</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">Pitch to Top Investors</h3>
                <p class="card-description">
                  Get ahead of 99% of your peers by directly pitching to Angel Investors, VCs, Private Equity, Royal Family Offices, Corporations, and Sovereign Wealth Funds actively looking for the next big thing in AI.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">Media Buzz</h3>
                <span class="card-number">3</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">Media Buzz</h3>
                <p class="card-description">
                  Gain exposure through our extensive media network. Get featured across multiple channels and publications, amplifying your startup's visibility to a global audience of decision-makers and industry leaders.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 4 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">AI-Powered Matchmaking</h3>
                <span class="card-number">4</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">AI-Powered Matchmaking</h3>
                <p class="card-description">
                  Connect with the right people using our AI-powered matchmaking platform. Get personalized recommendations for investors, partners, and customers based on your startup's unique profile and needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Curated for Investors Section -->
    <section class="investors-section">
      <div class="container">
        <h2 class="section-title">Startup Zone: Curated for Investors</h2>
        <p class="section-subtitle">
          <span class="price-tag">$1900!</span> Could Change Your Trajectory. Here's why
        </p>

        <div class="flip-cards-grid-two">
          <!-- Card 1 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">Official Investment Partners</h3>
                <span class="card-number">1</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">Official Investment Partners</h3>
                <p class="card-description">
                  Connect directly with our official investment partners who are actively seeking AI startups. These carefully vetted investors are ready to fund innovative solutions and scale promising ventures.
                </p>
              </div>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <h3 class="card-title">Matchmaker Lounge</h3>
                <span class="card-number">2</span>
              </div>
              <div class="flip-card-back">
                <h3 class="card-title">Matchmaker Lounge</h3>
                <p class="card-description">
                  Access our exclusive Matchmaker Lounge where AI algorithms pair startups with ideal investors based on sector focus, funding stage, and strategic alignment. Make meaningful connections that matter.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Where Startups and Investors Meet Section -->
    <section class="gallery-section">
      <div class="container">
        <h2 class="section-title">Where Startups and Investors Meet</h2>
        
        <div class="gallery-grid">
          <div class="gallery-item">
            <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="Startup Event" />
          </div>
          <div class="gallery-item">
            <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="Startup Event" />
          </div>
          <div class="gallery-item">
            <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="Startup Event" />
          </div>
          <div class="gallery-item">
            <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="Startup Event" />
          </div>
          <div class="gallery-item">
            <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="Startup Event" />
          </div>
        </div>
      </div>
    </section>

    <!-- What We Offer Section -->
    <section class="offers-section">
      <div class="container">
        <div class="offers-header">
          <div class="icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#E8562A"/>
            </svg>
          </div>
          <h2 class="section-title">What We Offer to Startups & Investors</h2>
        </div>

        <!-- For Startups Card -->
        <div class="offer-card">
          <div class="offer-card-content">
            <div class="offer-image">
              <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="For Startups" />
              <div class="offer-overlay">
                <h3 class="offer-title">For Startups</h3>
              </div>
            </div>
            <div class="offer-details">
              <div class="offer-item">
                <span class="offer-item-title">Demo Day</span>
                <div class="offer-item-icon">+</div>
              </div>
              <div class="offer-item">
                <span class="offer-item-title">Media Buzz</span>
                <div class="offer-item-icon">+</div>
              </div>
              <div class="offer-item">
                <span class="offer-item-title">Matchmaker Lounge</span>
                <div class="offer-item-icon">+</div>
              </div>
              <div class="offer-item">
                <span class="offer-item-title">Unmatched Exposure</span>
                <div class="offer-item-icon">+</div>
              </div>
            </div>
          </div>
        </div>

        <!-- For Investors Card -->
        <div class="offer-card">
          <div class="offer-card-content">
            <div class="offer-image">
              <img src="https://www.globalaishow.com/wp-content/uploads/2025/02/startup-img2-1-e1739165363436-768x934.webp" alt="For Investors" />
              <div class="offer-overlay">
                <h3 class="offer-title">For Investors</h3>
              </div>
            </div>
            <div class="offer-details">
              <div class="offer-item expanded">
                <div class="offer-item-header">
                  <span class="offer-item-title">InvestorX</span>
                  <div class="offer-item-icon expanded">-</div>
                </div>
                <p class="offer-item-description">
                  A dedicated session just for investors - no startups no founders. See what your peers are up to and learn from the top 1% with 10 min rapid-fire insights - no fluff, just pure insights.
                </p>
              </div>
              <div class="offer-item">
                <span class="offer-item-title">Investor Lounge</span>
                <div class="offer-item-icon">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="cta-content">
        <div class="icon-wrapper">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#E8562A"/>
          </svg>
        </div>
        <p class="cta-text">
          Join us in Riyadh and take the next big leap toward transforming your vision into reality.<br>
          Don't just attend—dominate!
        </p>
        <button class="cta-button" @click="goToContact">
          Get involved
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StartupZonePage',
  data() {
    return {
      // Add data properties here
    }
  },
  methods: {
    goToContact() {
      this.$router.push('/contact');
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero-section {
  position: relative;
  padding: 200px 20px 180px;
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/10/xlr8-banner.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  min-height: 500px;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 0;
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.page-title {
  font-size: 56px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -1px;
}

/* About Section */
.about-section {
  padding: 90px 20px;
  background: #ffffff;
}

.investors-section {
  padding: 90px 20px;
  background: #f7f8fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 16px 0;
  letter-spacing: -0.5px;
}

.section-subtitle {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin: 0 0 60px 0;
}

.price-tag {
  background: #E8562A;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 700;
  display: inline-block;
}

/* Flip Cards Grid */
.flip-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 40px;
}

.flip-cards-grid-two {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.flip-card {
  perspective: 1000px;
  height: 280px;
  cursor: pointer;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateX(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 16px;
  padding: 35px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.flip-card-front {
  background: #2a2a2a;
  color: #ffffff;
}

.flip-card-back {
  background: #E8562A;
  color: #ffffff;
  transform: rotateX(180deg);
}

.card-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
  z-index: 2;
  position: relative;
}

.card-number {
  font-size: 180px;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.1);
  position: absolute;
  bottom: -20px;
  right: 20px;
  line-height: 1;
  z-index: 1;
}

.card-description {
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
  color: #ffffff;
  z-index: 2;
  position: relative;
}

.flip-card-back .card-title {
  margin-bottom: 16px;
}

/* Decorative Icon */
.flip-card-back::after {
  content: '';
  position: absolute;
  bottom: 25px;
  right: 25px;
  width: 80px;
  height: 80px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="8" fill="rgba(255,255,255,0.3)"/><circle cx="30" cy="50" r="8" fill="rgba(255,255,255,0.3)"/><circle cx="70" cy="50" r="8" fill="rgba(255,255,255,0.3)"/><line x1="30" y1="50" x2="50" y2="30" stroke="rgba(255,255,255,0.3)" stroke-width="3"/><line x1="50" y1="30" x2="70" y2="50" stroke="rgba(255,255,255,0.3)" stroke-width="3"/><circle cx="50" cy="30" r="8" fill="rgba(255,255,255,0.3)"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.3;
  z-index: 1;
}

/* Gallery Section */
.gallery-section {
  padding: 60px 20px;
  background: white ;
}

.gallery-section .container {
  max-width: 1200px;
  margin: 0 auto;
}

.gallery-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  grid-template-rows: auto auto;
  gap: 15px;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  max-height: 280px;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.05);
}

/* First row: left column */
.gallery-item:nth-child(1) {
  grid-column: 1;
  grid-row: 1;
}

/* Middle column: spans 2 rows */
.gallery-item:nth-child(2) {
  grid-column: 2;
  grid-row: 1 / 3;
  max-height: 575px;
}

/* First row: right column top */
.gallery-item:nth-child(3) {
  grid-column: 3;
  grid-row: 1;
}

/* Second row: left column */
.gallery-item:nth-child(4) {
  grid-column: 1;
  grid-row: 2;
}

/* Second row: right column bottom */
.gallery-item:nth-child(5) {
  grid-column: 3;
  grid-row: 2;
}

/* Responsive */
@media (max-width: 960px) {
  .page-title {
    font-size: 44px;
  }

  .hero-content {
    padding: 0 20px;
  }

  .hero-section {
    padding: 140px 20px 120px;
    min-height: 400px;
  }

  .section-title {
    font-size: 36px;
  }

  .flip-cards-grid,
  .flip-cards-grid-two {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .flip-card {
    height: 260px;
  }

  .card-number {
    font-size: 140px;
  }

  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 15px;
  }

  .gallery-item:nth-child(1),
  .gallery-item:nth-child(2),
  .gallery-item:nth-child(3),
  .gallery-item:nth-child(4),
  .gallery-item:nth-child(5) {
    grid-column: auto !important;
    grid-row: auto !important;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 100px 15px 90px;
    min-height: 320px;
  }

  .page-title {
    font-size: 32px;
  }

  .hero-content {
    padding: 0 15px;
  }

  .section-title {
    font-size: 28px;
  }

  .section-subtitle {
    font-size: 16px;
  }

  .flip-card {
    height: 240px;
  }

  .flip-card-front,
  .flip-card-back {
    padding: 28px;
  }

  .card-title {
    font-size: 20px;
  }

  .card-description {
    font-size: 14px;
  }

  .card-number {
    font-size: 120px;
    bottom: -15px;
    right: 15px;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 15px;
  }

  .gallery-item:nth-child(1),
  .gallery-item:nth-child(2),
  .gallery-item:nth-child(3),
  .gallery-item:nth-child(4),
  .gallery-item:nth-child(5) {
    grid-column: auto;
    grid-row: auto;
  }
}

/* What We Offer Section */
.offers-section {
  padding: 80px 20px;
  background: white ;
}

.offers-section .container {
  max-width: 1200px;
  margin: 0 auto;
}

.offers-header {
  text-align: center;
  margin-bottom: 60px;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
}

.icon-wrapper svg {
  width: 100%;
  height: 100%;
}

.offer-card {
  margin: 0 auto 30px;
  background: #E8562A;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.offer-card-content {
  display: grid;
  grid-template-columns: 280px 1fr;
  min-height: 350px;
}

.offer-image {
  position: relative;
  overflow: hidden;
  border-radius: 20px 0 0 20px;
}

.offer-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}



.offer-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
  padding: 25px 20px;
}

.offer-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.offer-details {
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.offer-item {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 18px 20px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.offer-item:hover {
  background: rgba(255, 255, 255, 0.2);
}

.offer-item.expanded {
  background: rgba(255, 255, 255, 0.2);
  flex-direction: column;
  align-items: flex-start;
}

.offer-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
}

.offer-item-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  line-height: 1;
  cursor: pointer;
  transition: all 0.3s ease;
}

.offer-item-icon:hover {
  background: rgba(255, 255, 255, 0.4);
  border-color: white;
}

.offer-item-icon.expanded {
  background: rgba(255, 255, 255, 0.3);
}

.offer-item-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
}

.offer-item-description {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 15px;
  line-height: 1.6;
}

@media (max-width: 960px) {
  .flip-cards-grid,
  .flip-cards-grid-two {
    grid-template-columns: 1fr;
  }

  .offer-card-content {
    grid-template-columns: 1fr;
  }

  .offer-image {
    min-height: 300px;
    border-radius: 20px 20px 0 0;
  }

  .offer-details {
    padding: 30px 20px;
  }

  .gallery-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .offers-section {
    padding: 60px 15px;
  }

  .offer-title {
    font-size: 20px;
  }

  .offer-item-title {
    font-size: 16px;
  }

  .offer-item-icon {
    width: 28px;
    height: 28px;
    min-width: 28px;
    font-size: 18px;
  }

  .offer-item-description {
    margin-left: 0;
    font-size: 14px;
  }
}

/* CTA Section */
.cta-section {
  position: relative;
  padding: 120px 20px;
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/10/xlr8-banner.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 0;
}

.cta-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.cta-content .icon-wrapper {
  width: 70px;
  height: 70px;
  margin: 0 auto 30px;
}

.cta-text {
  font-size: 22px;
  color: white;
  line-height: 1.6;
  margin: 0 0 40px 0;
  font-weight: 400;
}

.cta-button {
  background: #E8562A;
  color: white;
  border: none;
  padding: 16px 40px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(232, 86, 42, 0.3);
}

.cta-button:hover {
  background: #d44819;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(232, 86, 42, 0.4);
}

.cta-button svg {
  transition: transform 0.3s ease;
}

.cta-button:hover svg {
  transform: translate(3px, -3px);
}

@media (max-width: 600px) {
  .cta-section {
    padding: 80px 20px;
  }

  .cta-text {
    font-size: 18px;
  }

  .cta-button {
    padding: 14px 32px;
    font-size: 16px;
  }
}
</style>
